import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Textarea } from '@wit-support/ui';
import { FieldShell } from './field-shell.js';
export function JsonWidget(props) {
    const { field, fieldState, meta, label, description, hint, readonly, disabled } = props;
    const [text, setText] = React.useState(() => {
        try {
            return field.value === undefined ? '' : JSON.stringify(field.value, null, 2);
        }
        catch {
            return String(field.value ?? '');
        }
    });
    const [parseError, setParseError] = React.useState(null);
    // Sync when outside value changes (e.g. reset).
    const lastExternal = React.useRef(field.value);
    React.useEffect(() => {
        if (field.value !== lastExternal.current) {
            lastExternal.current = field.value;
            try {
                setText(field.value === undefined ? '' : JSON.stringify(field.value, null, 2));
                setParseError(null);
            }
            catch {
                /* ignore */
            }
        }
    }, [field.value]);
    return (_jsxs(FieldShell, { meta: meta, fieldState: fieldState, label: label, description: description, hint: hint, htmlFor: field.name, children: [_jsx(Textarea, { id: field.name, ref: field.ref, value: text, onBlur: field.onBlur, onChange: (e) => {
                    const v = e.target.value;
                    setText(v);
                    if (v.trim() === '') {
                        setParseError(null);
                        field.onChange(undefined);
                        return;
                    }
                    try {
                        const parsed = JSON.parse(v);
                        setParseError(null);
                        field.onChange(parsed);
                    }
                    catch (err) {
                        setParseError(err.message);
                    }
                }, placeholder: meta.placeholder, readOnly: readonly ?? meta.readonly, disabled: disabled, className: "font-mono" }), parseError ? (_jsx("span", { className: "text-xs text-[var(--color-state-danger-fg)]", children: parseError })) : null] }));
}
//# sourceMappingURL=json.js.map